module.exports = __webpack_public_path__ + "img/facebook.65d88192.svg";